"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialGameState = void 0;
exports.isDouble = isDouble;
exports.diceToSteps = diceToSteps;
exports.stepPermutations = stepPermutations;
exports.makeAMove = makeAMove;
exports.addMoveInfo = addMoveInfo;
exports.getAllMovesFromPoint = getAllMovesFromPoint;
exports.diceEquals = diceEquals;
const Model_1 = require("./Model");
const board_1 = require("./board");
const lodash_1 = require("lodash");
const getInitialGameState = () => ({
    state: 'in-progress',
    turn: Model_1.WHITE,
    dice: null,
    board: (0, board_1.getInitialBoard)(),
});
exports.getInitialGameState = getInitialGameState;
function isDouble(dice) {
    if ((0, lodash_1.isNil)(dice)) {
        return false;
    }
    return dice.die1 === dice.die2;
}
function diceToSteps(dice) {
    if ((0, lodash_1.isNil)(dice)) {
        return [];
    }
    return isDouble(dice)
        ? [dice.die1, dice.die1, dice.die1, dice.die1]
        : [dice.die1, dice.die2];
}
function stepPermutations(steps) {
    if (steps.length === 0) {
        return [];
    }
    if (steps.length === 1) {
        return [steps];
    }
    if (steps.length === 2) {
        const [s1, s2] = steps;
        if (s1 === s2) {
            return [[s1], [s1, s1]];
        }
        return [[s1], [s2], [s1, s2], [s2, s1]];
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const s = steps[0];
    if (steps.length === 3) {
        return [[s], [s, s], [s, s, s]];
    }
    if (steps.length === 4) {
        return [[s], [s, s], [s, s, s], [s, s, s, s]];
    }
    return [];
}
function makeAMove(from, step) {
    return {
        from,
        to: Math.max(from - step, 0),
        step,
    };
}
function addMoveInfo(move, state) {
    return Object.assign(Object.assign({}, move), { isHit: (0, board_1.isHit)(state.board, state.turn, move), isBearOff: move.to <= Model_1.OFF_POINT });
}
function getAllMovesFromPoint(state, point, steps = diceToSteps(state.dice)) {
    const permutations = stepPermutations(steps);
    const allMoves = permutations
        .map((steps) => {
        let from = point;
        return steps.map((step) => {
            const move = makeAMove(from, step);
            from -= step;
            return move;
        });
    })
        .filter((moves) => moves.every((move) => move.from > Model_1.OFF_POINT));
    return allMoves;
}
function diceEquals(dice, a, b) {
    if ((0, lodash_1.isNil)(dice)) {
        return false;
    }
    return ((dice.die1 === a && dice.die2 === b) || (dice.die1 === b && dice.die2 === a));
}
